export default async function updateUser(userId, updatedData) {

    try {
        const userSession = JSON.parse(sessionStorage.getItem("user"));

        if (!userSession || !userSession.token) {
            throw new Error("Dados insuficientes no sessionStorage.");
        }

        const { token } = userSession;

        console.log("Parâmetros recebidos:", {userId, updatedData});
        console.log("JSON:", JSON.stringify(updatedData));

        const response = await fetch(`${process.env.REACT_APP_OPENAI_SERVER_EXPRESS}/users/update/${userId}`, {
            method: "PUT", // Método HTTP para atualizar
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
            body: JSON.stringify(updatedData), // Dados atualizados no corpo da requisição
        });



        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(`Erro ao atualizar usuário: ${errorData.error || response.statusText}`);
        }

        const data = await response.json();

        if (!data) {
            throw new Error("Resposta inválida da API.");
        }

        return data; // Retorna o resultado da API
    } catch (error) {
        console.error("Erro ao atualizar usuário:", error.message);
        throw error; // Propaga o erro para tratamento externo
    }
}
